import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {smsfilters, smsfilter,smsfilterActive,mateChannel, sysConfig} = api;



/**
 * 设置配置
 */
export async function setSysConfig(params) {
    return request({url: sysConfig, method: 'put', data: params})
}
/**
 * 设置配置
 */
export async function getSysConfig(params) {
    return request({url: sysConfig, method: 'get', data: params})
}

/**
 * 查找短信渠道列表
 */
export async function findSmsfilters(params) {
    return request({url: smsfilters, method: 'get', data: params})
}
/**
 * 查找短信渠道详情
 */
export async function findSmsfilter(params) {
    return request({url: smsfilter, method: 'get', data: params})
}
/**
 * 创建过滤器
 */
export async function createSmsfilters(params) {
    return request({url: smsfilters, method: 'post', data: params})
}
/**
 * 编辑过滤器
 */
export async function updateSmsfilter(params) {
    return request({url: smsfilter, method: 'put', data: params})
}
/**
 * 删除过滤器
 */
export async function deleteSmsfilter(params) {
    return request({url: smsfilter, method: 'delete', data: params})
}

/**
 * 变更状态
 */
export async function setSmsfilterActive(params) {
    return request({url: smsfilterActive, method: 'post', data: params})
}
/**
 * 验证渠道
 */
export async function findMateChannel(params) {
    return request({url: mateChannel, method: 'get', data: params})
}





// WEBPACK FOOTER //
// ./src/services/smsConfig.js